var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.41 6.41L17.58 3.58C17.21 3.21 16.7 3 16.17 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12.4L21 12.4V7.83C21 7.3 20.79 6.79 20.41 6.41ZM12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 12 12 12C13.66 12 15 13.34 15 15C15 16.66 13.66 18 12 18ZM15 9C15 9.55 14.55 10 14 10H7C6.45 10 6 9.55 6 9V7C6 6.45 6.45 6 7 6H14C14.55 6 15 6.45 15 7V9ZM19.99 16.25L21.76 18.02L16.92 22.86C16.82 22.95 16.69 23 16.56 23H15.5C15.22 23 15 22.78 15 22.5V21.44C15 21.31 15.05 21.18 15.15 21.09L19.99 16.25ZM23.25 16.51L22.4 17.36L20.63 15.59L21.48 14.74C21.68 14.54 21.99 14.54 22.19 14.74L23.25 15.8C23.45 16 23.45 16.32 23.25 16.51Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save_icon.c8296c6b1edfa29a909958b8ce5f77b0.svg";
export { ForwardRef as ReactComponent };